var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"textarea-root d-flex align-items-center",class:{
        'success-type': _vm.color === 'success',
        'error-type': _vm.color === 'error',
        outline: _vm.outline === true,
    }},[(_vm.label)?_c('h6',{staticClass:"subtitle bold"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',_vm._g(_vm._b({ref:"textarea",class:{
            'success-bg': _vm.color === 'success',
            'error-bg': _vm.color === 'error',
        },domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.listeners)),(_vm.helperText)?_c('h6',{staticClass:"subtitle mt-2",class:{ 'error-color': _vm.color === 'error' }},[_vm._v("\n        "+_vm._s(_vm.helperText)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }